//imports
import { all } from 'redux-saga/effects';

//Views

import vidfleetConfigurationSagas from 'Modules/vidfleet/.components/configuration/redux/saga';
import maintenanceWarningsSagas from 'Modules/vidfleet/views/maintenanceWarnings/redux/saga';
import cameraLogsSagas from 'Modules/vidfleet/views/cameraLogs/redux/saga';
import dmsStatusesSagas from 'Modules/vidfleet/views/dmsStatuses/redux/saga';
import powerLostSagas from 'Modules/vidfleet/views/powerLost/redux/saga';
import sdCardStatusSagas from 'Modules/vidfleet/views/sdCardStatus/redux/saga';
import vidfleetConfigurationUploadModeSagas from 'Modules/vidfleet/.components/configurationUploadMode/redux/saga';
import showChangesHistorySagas from 'Modules/vidfleet/.components/showChangesHistory/redux/saga';
import vidfleetConfigurationHubSpotSagas from 'Modules/vidfleet/.components/configurationHubSpot/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        vidfleetConfigurationSagas(),
        maintenanceWarningsSagas(),
        cameraLogsSagas(),
        dmsStatusesSagas(),
        powerLostSagas(),
        sdCardStatusSagas(),
        vidfleetConfigurationUploadModeSagas(),
        showChangesHistorySagas(),
        vidfleetConfigurationHubSpotSagas()
    ]);
}